export default "__VITE_ASSET__DNqZS6vp__"